const translations = {
    validAddress: 'Please enter a valid address'
};

export default translations;
